// src/utils/passwordValidation.js
// Shared password validation rules used by SignUpPage and ChangePasswordModal.

export const PASSWORD_RULES = [
  { id: "len", label: "At least 8 characters", test: (pw) => pw.length >= 8 },
  { id: "up", label: "One uppercase letter", test: (pw) => /[A-Z]/.test(pw) },
  { id: "low", label: "One lowercase letter", test: (pw) => /[a-z]/.test(pw) },
  { id: "num", label: "One number", test: (pw) => /\d/.test(pw) },
  {
    id: "sym",
    label: "One special character",
    test: (pw) => /[^A-Za-z0-9]/.test(pw),
  },
];

export function getPasswordRequirements(password) {
  const list = PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    ok: rule.test(password),
  }));
  return {
    list,
    allOk: list.every((r) => r.ok),
    missing: list.filter((r) => !r.ok).map((r) => r.label),
  };
}

export function getPasswordStrength(password) {
  return PASSWORD_RULES.reduce(
    (score, rule) => score + (rule.test(password) ? 1 : 0),
    0,
  );
}

export function getLockColor(password, requirements, strength) {
  if (password.length === 0) return "text-text-muted";
  if (requirements.allOk) return "text-green-600";
  if (strength <= 1) return "text-destructive";
  if (strength === 2) return "text-amber-500";
  return "text-yellow-500";
}

export function getConfirmLockColor(confirmPassword, password) {
  if (confirmPassword.length === 0) return "text-text-muted";
  return confirmPassword === password ? "text-green-600" : "text-destructive";
}
